// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddCasePopup_content_container__Nfiap {
}

.AddCasePopup_error_container__\\+5ZrX {
  padding: 10px;
  margin: 0px 5px 25px 5px;
  background-color: var(--color-theme-red);
}

.AddCasePopup_error_text__1a0e3 {
  font-size: 16px;
  color: var(--color-theme-white);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/AddCasePopup/AddCasePopup.module.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".content_container {\n}\n\n.error_container {\n  padding: 10px;\n  margin: 0px 5px 25px 5px;\n  background-color: var(--color-theme-red);\n}\n\n.error_text {\n  font-size: 16px;\n  color: var(--color-theme-white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `AddCasePopup_content_container__Nfiap`,
	"error_container": `AddCasePopup_error_container__+5ZrX`,
	"error_text": `AddCasePopup_error_text__1a0e3`
};
export default ___CSS_LOADER_EXPORT___;
